<template>
  <header id="header">
    <div class="inner">
      <router-link class="logo" to="/">
        <img alt="W E Pinder - Funeral Directors Doncaster" src="../assets/logo.jpg" />
      </router-link>
      <div class="actions" v-if="settings">
        <a :href="'tel:' + settings.telephone.replace(/ /g,'')" v-if="settings.telephone">
          <font-awesome-icon icon="phone-alt" />
          <span>
            Call us on
            <strong>{{ settings.telephone }}</strong>
          </span>
        </a>
        <page-link :to="reviews_page.url" v-if="reviews_page">
          <font-awesome-icon icon="star" />
          <span>
            Read our
            <strong>reviews</strong>
          </span>
        </page-link>
        <page-link :to="prices_page.url" v-if="prices_page">
          <font-awesome-icon icon="book-open" />
          <span>
            View our
            <strong>brochures</strong>
          </span>
        </page-link>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex"
import { mapGetters } from "vuex"

export default {
  name: "Header",
  computed: {
    ...mapState(["page", "prices_page", "reviews_page", "settings"]),
    ...mapGetters(["isHomePage"])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
header {
  background: #53453c;
  z-index: 7;
  width: 100%;
  height: 13rem;
  color: white;
}

.logo {
  display: inline-block;
  margin: 4rem 0;
}

.logo img {
  width: 25rem;
}

.actions {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

.actions a {
  display: inline-block;
  margin-left: 5rem;
}

.actions span {
  display: inline-block;
  padding-left: 1rem;
}

.actions svg {
  color: #ccb298;
}

@media screen and (max-width: 1050px) {
  .logo {
    position: relative;
    left: 8rem;
  }
}

@media screen and (max-width: 980px) {
  header {
    height: 9rem;
    z-index: 5;
  }
  .logo img {
    width: 100%;
  }
  .logo {
    display: block;
    margin: 3rem auto;
    width: 18rem;
    left: 0;
  }
  .actions {
    display: none;
  }
}
</style>
